import { Link } from "react-router-dom";

type Mode = "signup" | "login";

type Props = {
  mode: Mode;
};

export function AccountLegalNotice({ mode }: Props) {
  const lead =
    mode === "signup"
      ? "By signing up, you agree to TNK Main's"
      : "By logging in, you agree to TNK Main's";

  return (
    <p className="account-legal-notice">
      {lead}{" "}
      <Link to="/terms">Terms of Service</Link>,{" "}
      <Link to="/code-of-conduct">Code of Conduct</Link>, and{" "}
      <Link to="/privacy">Privacy Policy</Link>.
    </p>
  );
}
